import { APP_INITIALIZER, NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { ActivatedRoute, RouterModule } from "@angular/router";

import { HttpClientModule, HttpClientJsonpModule } from "@angular/common/http";
/* Component Loader */
import { AppComponent } from "./components/app/app.component";
import { SchedulerComponent } from "./components/scheduler/scheduler.component";
import { TopHeaderComponent } from "./components/topHeader/topHeader.component";
import { NotFoundComponent } from "./components/notFound/notFound.component";
import { SchedulerAsideComponent } from "./components/scheduler/schedulerAside/schedulerAside.component";
import { LibraryHeaderComponent } from "./components/scheduler/libraryHeader/libraryHeader.component";
import { LibraryComponent } from "./components/scheduler/library/library.component";
import { LibraryItemComponent } from "./components/scheduler/libraryItem/libraryItem.component";
import { LibraryUploaderComponent } from "./components/scheduler/libraryUploader/libraryUploader.component";
import { LibraryHeaderFilterComponent } from "./components/scheduler/libraryHeaderFilter/libraryHeaderFilter.component";
/* Common Components*/
import { SettingsButtonComponent } from "./components/common/settings-button/settings-button.component";
import { AlertsNotificationButtonComponent } from "./components/common/alerts-notification-button/alerts-notification-button.component";
/* Live*/
import { LiveComponent } from "./components/live/live.component";
/* User Alerts*/
import { AlertsComponent } from "./components/alerts/alerts.component";
import { AlertSettingsComponent } from "./components/alerts/alert-settings/alert-settings.component";
import { AlertsTypeComponent } from "./components/alerts/alerts-type/alerts-type.component";
/* Common Components */
import { ButtonComponent } from "./components/common/button/button.component";
import { SearchInputComponent } from "./components/common/searchInput/searchInput.component";
import { AlertComponent } from "./components/common/alert/alert.component";
import { CalendarComponent } from "./components/calendar/calendar.component";
import { CalendarGridComponent } from "./components/calendar/calendar-grid.component";
import { FilterComponent } from "./components/scheduler/filter/filter.component";
import { ClockComponent } from "./components/topHeader/clock/clock.component";
import { VideoPreviewComponent } from "./components/videoPreview/videoPreview.component";
import { CalendarVideoComponent } from "./components/calendar/calendar-video.component";
import { MediaEditorComponent } from "./components/mediaEditor/mediaEditor.component";
import { TabsComponent } from "./components/common/tabs/tabs.component";
import { BackButtonComponent } from "./components/mediaEditor/backButton/backButton.component";

import { TextareaComponent } from "./components/common/textarea/textarea.component";
import { TagComponent } from "./components/common/tag/tag.component";
import { TagsWrapperComponent } from "./components/common/tagsWrapper/tagsWrapper.component";
import { Config } from "./services/config.service";
import { UI } from "./services/ui.service";
import { InitService } from "./services/init.service";
import { ErrorComponent } from "./components/error/error.component";
import { EditGraphicsComponent } from "./components/graphics/edit/edit-graphics.component";
import { AutocompleteComponent } from "./components/common/autocomplete/autocomplete.component";
import { DurationComponent } from "./components/common/duration/duration.component";
import { DateinputComponent } from "./components/common/dateinput/dateinput.component";
import { EditGraphicsMainComponent } from "./components/graphics/edit/edit-graphics-main.component";
import { EditGraphicsAsideComponent } from "./components/graphics/edit/edit-graphics-aside.component";

import { AutopilotComponent } from "./components/autopilot/autopilot.component";
import { ChannelComponent } from "./components/channel/channel.component";
import { AutopilotNavComponent } from "./components/autopilot/autopilot-nav.component";
import { AutopilotRuleWizardComponent } from "./components/autopilot/graphicsRuleWizard/autopilot-rule-wizard.component";
import { ProgressBarComponent } from "./components/common/progressbar/progressbar.component";
import { InlineSVGModule } from "ng-inline-svg-2";
import { SidebarNavComponent } from "./components/common/sideNav/sidebar-nav.component";
import { GraphicsColorsComponent } from "./components/graphics/edit/fields/colors.component";
import { GraphicsColorComponent } from "./components/graphics/edit/fields/color.component";
import { GraphicsMediaComponent } from "./components/graphics/edit/fields/media.component";
import { GraphicsMediaItemComponent } from "./components/graphics/edit/fields/media-item.component";
import { GraphicsScalePositionComponent } from "./components/graphics/edit/fields/scale-position.component";
import { GraphicsPositionComponent } from "./components/graphics/edit/fields/position.component";
import { GraphicsScaleComponent } from "./components/graphics/edit/fields/scale.component";
import { GraphicsTextComponent } from "./components/graphics/edit/fields/text.component";
import { GraphicsTextLinkComponent } from "./components/graphics/edit/fields/text-link.component";
import { GraphicsTextFontComponent } from "./components/graphics/edit/fields/text-font.component";
import { SegmentButtonComponent } from "./components/common/segment/segment-button.component";
import { SegmentComponent } from "./components/common/segment/segment.component";
import { GraphicsTextDynamicOptionsComponent } from "./components/graphics/edit/fields/text-dynamic-options.component";
import { GraphicsTextTickerComponent } from "./components/graphics/edit/fields/text-ticker.component";
import { GraphicLibraryItemComponent } from "./components/scheduler/libraryItem/graphic/graphicLibraryItem.component";
import { GraphicsRuleWizardNavComponent } from "./components/autopilot/graphicsRuleWizard/graphics-rule-wizard-nav.component";
import { WizardComponent } from "./components/common/wizard/wizard.component";
import { WizardSummaryComponent } from "./components/common/wizard/wizard-summary.component";
import { WizardStepComponent } from "./components/common/wizard/wizard-step.component";
import { WizardNavComponent } from "./components/common/wizard/wizard-nav.component";
import { WizardSubstepComponent } from "./components/common/wizard/wizard-substep.component";
import { GraphicsRuleWizardStep1Substep1Component } from "./components/autopilot/graphicsRuleWizard/step1/substep1";
import { AutopilotRuleWizardStep1Substep2Component } from "./components/autopilot/graphicsRuleWizard/step1/substep2";
import { AutopilotRuleWizardStep2Substep2Component } from "./components/autopilot/graphicsRuleWizard/step2/substep2";
import { AutopilotRuleWizardStep3Substep1Component } from "./components/autopilot/graphicsRuleWizard/step3/substep1";
import { AutopilotRuleWizardDoneComponent } from "./components/autopilot/graphicsRuleWizard/done/done";
import { HourPickerComponent } from "./components/common/hourPicker/hour-picker.component";
import { Auth } from "./infrastructure/auth";
import { HttpService } from "./infrastructure/http/http";
import { LibraryWrapperComponent } from "./components/common/libraryWrapper/libraryWrapper.component";
import { AutopilotAsideComponent } from "./components/autopilot/autopilotAside/autopilotAside.component";
import { RuleLibraryItemComponent } from "./components/scheduler/libraryItem/rule/ruleLibraryItem.component";
import { ChannelWizardComponent } from "./components/channel/channel-wizard/channel-wizard.component";
import { ChannelWizardStep1Substep1Component } from "./components/channel/channel-wizard/step1/substep1";
import { ChannelWizardStep1Substep2Component } from "./components/channel/channel-wizard/step1/substep2";
import { ChannelWizardStep2Substep1Component } from "./components/channel/channel-wizard/step2/substep1";
import { PlatformsCollapsibleComponent } from "./components/channel/platformsCollapsible/platforms-collapsible.component";
import { FacebookPlatformComponent } from "./components/channel/platforms/facebook/facebook-platform.component";
import { ChannelWizardDoneComponent } from "./components/channel/channel-wizard/done/done";
import { GraphicsRepository } from "./domain/graphics-repository";
import { GraphicsMapper } from "./infrastructure/repositories/graphics/graphics.mapper";
import { Logger } from "./infrastructure/logger";
import { GraphicsRepositoryImpl } from "./infrastructure/repositories/graphics/graphics";
import { MediaRepositoryImpl } from "./infrastructure/repositories/media/media";
import { MediaRepository } from "./domain/media-repository";
import { MediaMapper } from "./infrastructure/repositories/media/media.mapper";
import { TagRepository } from "./domain/tag-repository";
import { CachedTagRepositoryImpl } from "./infrastructure/repositories/tags/tag";
import { TagMapper } from "./infrastructure/repositories/tags/tag.mapper";
import { Socket } from "./infrastructure/socket.service";
import { AutopilotMapper } from "./infrastructure/repositories/autopilot/autopilot.mapper";
import { AutopilotRepositoryImpl } from "./infrastructure/repositories/autopilot/autopilot";
import { AutopilotRepository } from "./domain/autopilot-repository";
import { UserService } from "./domain/user-service";
import { UserRepository } from "./domain/user-repository";
import { UsersRepositoryImpl } from "./infrastructure/repositories/user/user";
import { UserMapper } from "./infrastructure/repositories/user/user.mapper";
import { NavBarMenuItemComponent } from "./components/common/navbar-menu/navbar-menu-item.component";
import { NavBarMenuComponent } from "./components/common/navbar-menu/navbar-menu.component";
import { EditMediaFilesTabComponent } from "./components/mediaEditor/files-tab/edit-media-files-tab.component";
import { UploadService } from "./infrastructure/upload/upload-service";

import { FileLabelComponent } from "./components/mediaEditor/files-tab/label/label.component";
import { FileUploadComponent } from "./components/mediaEditor/files-tab/upload/upload.component";
import { FileAnalyzeComponent } from "./components/mediaEditor/files-tab/analyze/analyze.component";
import { FileThumbnailComponent } from "./components/mediaEditor/files-tab/thumbnail/thumbnail.component";

import { SubtitlesComponent } from "./components/calendar/subtitles-popover.component";
import { FirstTimerComponent } from "./components/channel/first-timer/first-timer";
import { ChannelsDashboardComponent } from "./components/channel/channels-dashboard/channels-dashboard.component";
import { CustomPlatformComponent } from "./components/channel/platforms/custom/custom-platform.component";
import { CalendarListComponent } from "./components/calendar/calendar-list.component";
import { PopoverModule } from "./components/pop-over";
import { InfiniteScrollModule } from "ngx-infinite-scroll";
import { VirtualScrollerModule } from "@iharbeck/ngx-virtual-scroller";
import { UploadStatusReport } from "./components/uploads-report/uploads-report.component";
import { SectionProgressbarComponent } from "./components/common/section-progressbar/section-progressbar.component";
import { ChannelPreviewComponent } from "./components/channel/channel-preview/channel-preview.component";
import { CircleIndicator } from "./components/common/circleIndicator/circleIndicator.component";
import { DragImageComponent } from "./components/channel/channel-wizard/step1/drag-image.component";
import { ChannelRepository } from "./domain/channel-repository";
import { ChannelRepositoryImpl } from "./infrastructure/repositories/channel/channel";
import { ChannelMapper } from "./infrastructure/repositories/channel/channel.mapper";
import { CountryService } from "./domain/country-service";
import { EditCodecPopupComponent } from "./components/channel/platforms/custom/edit-codec-popup.component";
import { UploadMediaReportRepository } from "./domain/upload-media-report-repository";
import { UploadMediaReportRepositoryImpl } from "./infrastructure/repositories/upload-media-report/upload-media-report";
import { SwitchToggleComponent } from "./components/common/switchToggle/switchToggle.component";
import { SubtitleRepository } from "./domain/subtitle-repository";
import { SubtitleRepositoryImpl } from "./infrastructure/repositories/subtitles/subtitle";
import { ExportEpgComponent } from "./components/export-epg/export-epg";
import { ExportRunLogComponent } from "./components/export-run-log/export-run-log";
import { UploadGraphicsComponent } from "./components/upload-graphics/upload-graphics";
import { SearchService } from "./services/search.service";
import { SplitScreen } from "./components/common/splitScreen/splitScreen.component";
import { LiveInputComponent } from "./components/live/liveInput.component/liveInput.component";
import { LivePreviewComponent } from "./components/live/livePreview.component/livePreview.component";
import { CapsuleComponent } from "./components/common/capsule/capsule.component";
import { LiveSwitcherComponent } from "./components/live/liveSwitcher.component/liveSwitcher.component";
import { GoLiveButtonComponent } from "./components/common/goLiveButton/goLiveButton.component";
import { LiveIndicatorComponent } from "./components/common/LiveIndicator/liveIndicator.component";
import { SoundBarComponent } from "./components/common/soundBar/soundBar.component";
import { AudioMixerComponent } from "./components/common/audioMixer/audioMixer.component";
import { CodePopupComponent } from "./components/channel/channels-dashboard/code-popup";

import { ExportPlatformsComponent } from "./components/export-platforms/export-platforms";
import { BatchImportComponent } from "./components/batch-import/batch-import";
import { EditBatchRuleComponent } from "./components/batch-import/edit-rule";
import { BatchRulesRepository } from "./domain/batch-rules-repository";
import { BatchRulesRepositoryImpl } from "./infrastructure/repositories/batch-import/batch-rules-repository";
import { ContextMenuModule } from "@perfectmemory/ngx-contextmenu";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { GraphicsDurationComponent } from "./components/graphics/edit/fields/duration";
import { AudioRepository } from "./domain/audio-repository";
import { AudioRepositoryIml } from "./infrastructure/repositories/audio/audio";
import { CalendarSearchComponent } from "./components/calendar/calendar-search.component";
import { CalendarService } from "./domain/calendar-service";
import { CalendarUIService } from "./domain/calendar-ui-service";
import { CalendarSearchService } from "./components/calendar/services/calendar-search.service";
import { CalendarSearchPipe } from "./components/calendar/services/calendar-search.pipe";
import { CleanSchedulerComponent } from "./components/clean-scheduler/clean-scheduler";

import { ReplaceShowModalComponent } from "./components/calendar/replace-show/replace-show-modal.component";
import { BellButtonComponent } from "./components/common/bell-button/bell-button.component";
import { RenameShowModalComponent } from "./components/calendar/rename-show-modal.component";
import { LiveFeedRepository } from "./domain/live-feed-repository";
import { LiveFeedRepositoryImpl } from "./infrastructure/repositories/live-feed/live-feed";
import { LiveFeedLibraryItemComponent } from "./components/scheduler/libraryItem/live-feed/liveFeedLibraryItem";
import { ShowRepositoryImpl } from "./infrastructure/repositories/show/show";
import { ShowRepository } from "./domain/show-repository";
import { LiveFeedCreateEditComponent } from "./components/live/createEditLiveFeed/live-feed-create-edit.component";
import { ToastrModule } from "ngx-toastr";

import { NgxDatatableModule } from "@swimlane/ngx-datatable";
import { WindowsNotificationService } from "./services/windows-notification.service";
import { ChooseTemplateComponent } from "./components/tenant/choose-template/choose-template.component";
import { TenantComponent } from "./components/tenant/tenant.component";
import { RequestDemoComponent } from "./components/tenant/request-demo/request-demo.component";
import { LiveFeedPreviewComponent } from "./components/live/createEditLiveFeed/live-feed-preview.component";
import { PopoverService } from "./services/popover-service";
import { TenantSettingsRepository } from "./domain/tenant-settings-repository";
import { CachedTenantSettingsRepositoryImpl } from "./infrastructure/repositories/tenant/tenantSettings";
import { TenantSettingsComponent } from "./components/tenant/tenant-settings.component";
import { DestinationSettingsModule } from "./components/destinations/destination-settings/destination-settings.module";
import { CalendarHeaderComponent } from "./components/calendar/calendar-header/calendar-header.component";

import { ChooseTemplateTemplatesWindowComponent } from "./components/tenant/choose-template/templates-window/templates-window.component";
import { ChooseTemplateItemComponent } from "./components/tenant/choose-template/templates-window/template-item/template-item.component";
import { ChooseTemplateSideMenuComponent } from "./components/tenant/choose-template/side-menu/side-menu.component";
import { EnterChannelName } from "./components/tenant/choose-template/enter-channel-name/enter-channel-name.component";
import { ChannelTemplateRepository } from "./domain/channel-template-repository";
import { ChannelTemplateRepositoryCached } from "./infrastructure/repositories/channel/template/channel-template-repository";
import {
  ChannelTemplatesCategoryFilter,
  ChannelTemplatesSearchFilter,
} from "./components/tenant/choose-template/pipes/templates-wizzard-filter.pipe";
import { SearchInputDumbComponent } from "./components/common/search-input-dumb/search-input-dumb.component";
import { StorageService } from "./services/storage.service";
import { EqualValidator } from "./directives/equal-validator.directive";
import { SessionStorageService } from "./services/session-storage.service";
import { TenantRepository } from "./domain/tenant-repository";
import { TenantRepositoryImpl } from "./infrastructure/repositories/tenant/tenant";
import { CategoryRepository } from "./domain/category-repository";
import { CategoryRepositoryImpl } from "./infrastructure/repositories/category/category";
import { RequestDemoSuccessWindowComponent } from "./components/tenant/choose-template/success-window/success-window.component";
import { DynamicPromoLibraryItemComponent } from "./components/scheduler/libraryItem/dynamic-promo/dynamicPromoLibraryItem";
import { DynamicPromoCreateEditComponent } from "./components/dynamic-promo/dynamic-promo-create-edit";
import { DynamicPromoRepository } from "./domain/dynamic-promo-repository";
import { DynamicPromoRepositoryImpl } from "./infrastructure/repositories/dynamic-promo/dynamic-promo";
import { UsersListComponent } from "./components/user/users-list/users-list.component";
import { EditUserComponent } from "./components/user/edit-user/edit-user.component";
import { AddNewUserComponent } from "./components/user/add-new-user/add-new-user.component";
import { UsersComponent } from "./components/user/users/users.component";
import { UserFormComponent } from "./components/user/common/user-form/user-form.component";
import { QualityCheckComponent } from "./components/quality-check/quality-check";
import { SchedulerAsideService } from "./components/scheduler/schedulerAside/scheduler-aside-service";
import { TimePickerComponent } from "./components/common/time-picker/time-picker.component";
import { DayOfWeekPickerComponent } from "./components/common/day-of-week-picker/day-of-week-picker.component";
import { DynamicPromoSettingsComponent } from "./components/channel/channel-wizard/dynamic-promo-settings/dynamic-promo-settings.component";
import { AppRoutes } from "./app.routes";
import { EvrideoCommonModule } from "./components/common/evrideo-common.module";
import { RecordingModule } from "./components/recording/recording.module";
import { RecordingService } from "./services/recording/recording.service";
import { MediaService } from "./services/media/media.service";
import { TenantService } from "./services/tenant.service";
import { CloudStorageProviderFactory } from "./infrastructure/upload/cloud-storage-provider-factory";
import { ICloudStorageProviderFactory } from "./domain/Upload/i-cloud-storage-provider-factory";
import { UserBrandingRepository } from "./infrastructure/repositories/user-branding/user-branding-repository";
import { IUserBrandingRepository } from "./domain/user-branding-repository";
import { UserBrandingService } from "./domain/user-branding-service";
import { ReplaceShowModalItemIsLongerComponent } from "./components/calendar/replace-show/item-is-longer/item-is-longer.component";
import { ReplaceShowModalItemIsShorterComponent } from "./components/calendar/replace-show/item-is-shorter/item-is-shorter.component";
import { UserPersonalInfoComponent } from "./components/user/common/user-form/user-personal-info/user-personal-info.component";
import { UserChannelPermissionsComponent } from "./components/user/common/user-form/user-channel-permissions/user-channel-permissions.component";
import { UserActionPermissionsComponent } from "./components/user/common/user-form/user-action-permissions/user-action-permissions.component";
import { EvrideoGuardsModule } from "./guards/evrideo-guards.module";
import { FuturePreviewComponent } from "./components/channel/future-preview/future-preview.component";
import { AngularDraggableModule } from "angular2-draggable";
import { MediaTranscoderModule } from "./components/media-transcoder/media-transcoder.module";
import { MediaTranscoderComponent } from "./components/media-transcoder/media-transcoder.component";
import { SuperuserService } from "./services/superuser.service";
import { IMediaTranscoderRepository } from "./domain/media-transcoder/media-transcoder.repository";
import { MediaTranscoderRepository } from "./infrastructure/repositories/media-transcoder/media-transcoder-repository";
import { CommonUtils } from "./infrastructure/common/CommonUtils";
import { ICommonUtilInterface } from "./domain/common/common-util.interface";

import { CalendarExpandableComponent } from "./components/calendar/expandable/calendar-expandable/calendar-expandable.component";
import { CalendarExpandableEditableTimeComponent } from "./components/calendar/expandable/calendar-expandable-editable-time/calendar-expandable-editable-time.component";
import { CalendarExpandableProgressBarComponent } from "./components/calendar/expandable/calendar-expandable-progress-bar/calendar-expandable-progress-bar.component";
import { CalendarExpandableAutopilotEventComponent } from "./components/calendar/expandable/calendar-expandable-autopilot-event/calendar-expandable-autopilot-event.component";
import { CalendarExpandableGraphicsEventComponent } from "./components/calendar/expandable/calendar-expandable-graphics-event/calendar-expandable-graphics-event.component";
import { CalendarExpandableSignalEventComponent } from "./components/calendar/expandable/calendar-expandable-signal-event/calendar-expandable-signal-event.component";
import { CalendarExpandableFloatingMediaEventComponent } from "./components/calendar/expandable/calendar-expandable-floating-media-event/calendar-expandable-floating-media-event.component";
import { CalendarExpandablePickerComponent } from "./components/calendar/expandable/calendar-expandable-picker/calendar-expandable-picker.component";
import { CalendarExpandableInOutPickerComponent } from "./components/calendar/expandable/calendar-expandable-in-out-picker/calendar-expandable-in-out-picker.component";
import { CalendarExpandableRedLineIndicatorComponent } from "./components/calendar/expandable/calendar-expandable-red-line-indicator/calendar-expandable-red-line-indicator.component";
import { CalendarFilterSecEventsComponent } from "./components/calendar/calendar-filter-sec-events/calendar-filter-sec-events.component";
import { CalendarExpandableNewSecEventComponent } from "./components/calendar/expandable/calendar-expandable-new-sec-event/calendar-expandable-new-sec-event.component";
import { MarkerLibraryItemComponent } from "./components/scheduler/libraryItem/marker-library-item/marker-library-item.component";
import { CalendarGridSecEventsPopupComponent } from "./components/calendar/calendar-grid-sec-events-popup/calendar-grid-sec-events-popup.component";
import { DtmfPopoverComponent } from "./components/calendar/dtmf-popover/dtmf-popover.component";
import { MarkerPopoverComponent } from "./components/calendar/marker-popover/marker-popover.component";
import { ITenantStorageOptionRepository } from "./domain/tenant-storage-option";
import { TenantStorageOptionRepository } from "./infrastructure/repositories/batch-import/tenant-storage-options-repository";
import { ImportSegmentsCsvComponent } from "./components/import-segments-csv/import-segments-csv.component";
import { CopyShowsViewModel } from "./services/show/copy-shows.view-model";
import { LoopFillShowsPopupComponent } from "./components/calendar/loop-fill-shows-popup/loop-fill-shows-popup.component";
import { ChannelJsonEditorComponent } from "./components/channel/channel-json-editor/channel-json-editor.component";
import { MonitoringModule } from "./components/monitoring/monitoring.module";
import { OutpostModule } from "./components/outpost/outpost.module";
import { AutopilotRuleWizardStep2Substep1Component } from "./components/autopilot/graphicsRuleWizard/step2/substep1";
import { LayoutsModule } from "./components/layouts/layouts.module";
import { LayoutLibraryItemComponent } from "./components/scheduler/libraryItem/layout-library-item/layout-library-item.component";
import { BlocksModule } from "./components/blocks/blocks.module";
import { BlocksCalendarComponent } from "./components/blocks/blocks-calendar/blocks-calendar.component";
import { BlockLibraryItemComponent } from "./components/scheduler/libraryItem/block-library-item/block-library-item.component";
import { EditBlockHeaderComponent } from "./components/blocks/edit-block-header/edit-block-header.component";
import { BroadcastsModule } from "./components/broadcast/broadcasts.module";
import { BroadcastLibraryItemComponent } from "./components/scheduler/libraryItem/broadcast-library-item/broadcast-library-item.component";
import { DragulaModule } from "ng2-dragula";
import { ExternalMAMModule } from "./components/external-mam/external-mam.module";
import { CalendarGridColumnsCustomizationComponent } from "./components/calendar/calendar-grid-columns-customization/calendar-grid-columns-customization.component";
import { ReportsModule } from "./components/reports/reports.module";
import { LiveSourcesModule } from "./components/live-sources/live-sources.module";
import { ReportsService } from "./services/reports.service";
import { CsvExportService } from "./services/csv-export.service";
import { ContentControlModule } from "./components/content-control/content-control.module";
import { ClippingStudioModule } from "./components/clipping-studio/clipping-studio.module";
import { TenantSettingsSelectAiModelComponent } from "./components/tenant/tenant-settings-select-ai-model/tenant-settings-select-ai-model.component";
import { UserBrandingModule } from "./components/user-branding/user-branding.module";
import { ArraysService } from "./services/arrays.service";
import { LiveOtherUserEnteredComponent } from "./components/live/live-other-user-entered/live-other-user-entered.component";
import { DownloadRecordingComponent } from "./components/channel/channels-dashboard/download-recording/download-recording.component";
import { ChooseDayAndTimeComponent } from "./components/graphics/edit/choose-day-and-time/choose-day-and-time.component";
import { OutpostRepository } from "./domain/outposts/outpost-repository";
import { OutpostRepositoryImpl } from "./infrastructure/repositories/outpost/outpost";

export function appInitFactory(
  initService: InitService,
  route: ActivatedRoute,
) {
  return async () => {
    document.getElementById("loading-message").innerHTML = "Connecting..";
    document.getElementById("loading-message").style.left = "-15px";

    const userBrandingService = initService.getUserBrandingService();
    const userBrandingSettings =
      await userBrandingService.getUserBrandingSettings();

    document.title = userBrandingSettings.windowTitle;
    document.getElementById("appLoadingHeader").innerHTML =
      userBrandingSettings.headerText;
    document
      .getElementById("linkFavicon")
      .setAttribute("href", userBrandingSettings.faviconUrl);
    document
      .getElementById("imgBrowserTooSmallImage")
      .setAttribute("src", userBrandingSettings.browserTooSmallImageUrl);
    document
      .getElementById("imgLestSideImage")
      .setAttribute("src", userBrandingSettings.sideImageUrl);
    document
      .getElementById("imgLoadingImage")
      .setAttribute("src", userBrandingSettings.loadingImageUrl);
    console.log(window.location.href);
    return initService.init();
  };
}

@NgModule({
  imports: [
    HttpClientModule,
    AngularDraggableModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    EvrideoCommonModule,
    EvrideoGuardsModule,
    RecordingModule,
    MediaTranscoderModule,
    UserBrandingModule,
    HttpClientJsonpModule,
    ToastrModule.forRoot({
      positionClass: "toast-top-center",
      tapToDismiss: false,
      timeOut: 2000,
      enableHtml: true,
    }),
    PopoverModule,
    InfiniteScrollModule,
    VirtualScrollerModule,
    BrowserAnimationsModule,
    RouterModule.forRoot(AppRoutes),
    HttpClientJsonpModule,
    ContextMenuModule,
    InlineSVGModule.forRoot(),
    /* Third Parties*/
    NgxDatatableModule,
    DragulaModule.forRoot(),
    MonitoringModule,
    OutpostModule,
    LayoutsModule,
    BlocksModule,
    BroadcastsModule,
    ExternalMAMModule,
    ReportsModule,
    LiveSourcesModule,
    ContentControlModule,
    ClippingStudioModule,
    DestinationSettingsModule,
  ],
  declarations: [
    AppComponent,
    SplitScreen,
    CalendarHeaderComponent,
    LiveInputComponent,
    LivePreviewComponent,
    LiveSwitcherComponent,
    CapsuleComponent,
    GoLiveButtonComponent,
    LiveIndicatorComponent,
    SoundBarComponent,
    AudioMixerComponent,
    LiveFeedCreateEditComponent,
    DynamicPromoCreateEditComponent,
    SchedulerComponent,
    SchedulerAsideComponent,
    AutopilotAsideComponent,
    SidebarNavComponent,
    LibraryItemComponent,
    LiveFeedLibraryItemComponent,
    DynamicPromoLibraryItemComponent,
    GraphicLibraryItemComponent,
    RuleLibraryItemComponent,
    LibraryWrapperComponent,
    LibraryUploaderComponent,
    LibraryHeaderComponent,
    LibraryComponent,
    LibraryHeaderFilterComponent,
    FilterComponent,
    TopHeaderComponent,
    NotFoundComponent,
    DurationComponent,
    SearchInputComponent,
    SearchInputDumbComponent,
    AlertComponent,
    CalendarComponent,
    CalendarGridComponent,
    CalendarVideoComponent,
    CalendarSearchComponent,

    MediaEditorComponent,
    BackButtonComponent,
    ClockComponent,
    VideoPreviewComponent,
    TabsComponent,
    TextareaComponent,
    // DropdownComponent,
    SwitchToggleComponent,
    TagComponent,
    TagsWrapperComponent,
    ErrorComponent,
    EditGraphicsComponent,
    EditGraphicsMainComponent,
    EditGraphicsAsideComponent,
    AutocompleteComponent,
    WizardComponent,
    WizardStepComponent,
    WizardSummaryComponent,
    WizardNavComponent,
    WizardSubstepComponent,
    AutopilotComponent,
    AutopilotNavComponent,
    AutopilotRuleWizardComponent,
    GraphicsRuleWizardStep1Substep1Component,
    AutopilotRuleWizardStep1Substep2Component,
    AutopilotRuleWizardStep2Substep1Component,
    AutopilotRuleWizardStep2Substep2Component,
    AutopilotRuleWizardStep3Substep1Component,
    AutopilotRuleWizardDoneComponent,
    GraphicsRuleWizardNavComponent,
    ProgressBarComponent,
    ChannelComponent,
    GraphicsColorsComponent,
    GraphicsColorComponent,
    GraphicsMediaComponent,
    GraphicsMediaItemComponent,
    GraphicsScalePositionComponent,
    GraphicsPositionComponent,
    GraphicsScaleComponent,
    GraphicsDurationComponent,
    GraphicsTextComponent,
    GraphicsTextLinkComponent,
    GraphicsTextFontComponent,
    GraphicsTextDynamicOptionsComponent,
    GraphicsTextTickerComponent,
    SegmentButtonComponent,
    SegmentComponent,
    HourPickerComponent,
    ChannelWizardComponent,
    ChannelWizardStep1Substep1Component,
    ChannelWizardStep1Substep2Component,
    ChannelWizardStep2Substep1Component,
    PlatformsCollapsibleComponent,
    FacebookPlatformComponent,
    ChannelWizardDoneComponent,
    NavBarMenuItemComponent,
    NavBarMenuComponent,
    FirstTimerComponent,
    NavBarMenuComponent,
    EditMediaFilesTabComponent,
    FileLabelComponent,
    FileThumbnailComponent,
    FileUploadComponent,
    FileAnalyzeComponent,
    ChannelsDashboardComponent,
    CustomPlatformComponent,
    SubtitlesComponent,
    CircleIndicator,
    DragImageComponent,
    EditCodecPopupComponent,
    ChannelPreviewComponent,
    SectionProgressbarComponent,
    UploadStatusReport,
    CalendarListComponent,
    ExportEpgComponent,
    ExportRunLogComponent,
    CleanSchedulerComponent,

    UploadGraphicsComponent,
    ExportPlatformsComponent,
    LiveComponent,
    CodePopupComponent,
    DownloadRecordingComponent,
    BatchImportComponent,
    EditBatchRuleComponent,
    ReplaceShowModalComponent,
    BellButtonComponent,
    RenameShowModalComponent,

    /* Pipes */
    CalendarSearchPipe,
    ChannelTemplatesSearchFilter,
    ChannelTemplatesCategoryFilter,
    /*User Alerts*/
    AlertsComponent,
    AlertSettingsComponent,
    AlertsTypeComponent,
    /*Common Components*/
    AlertsNotificationButtonComponent,
    LiveFeedPreviewComponent,
    TenantSettingsComponent,
    ChooseTemplateComponent,
    RequestDemoComponent,
    TenantComponent,
    ChooseTemplateTemplatesWindowComponent,
    ChooseTemplateItemComponent,
    ChooseTemplateSideMenuComponent,
    EnterChannelName,
    RequestDemoSuccessWindowComponent,
    QualityCheckComponent,
    /*Directives*/
    EqualValidator,
    /*Users*/
    UsersListComponent,
    AddNewUserComponent,
    EditUserComponent,
    UsersComponent,
    UserFormComponent,
    TimePickerComponent,
    DayOfWeekPickerComponent,
    DynamicPromoSettingsComponent,
    ReplaceShowModalItemIsShorterComponent,
    ReplaceShowModalItemIsLongerComponent,
    UserPersonalInfoComponent,
    UserChannelPermissionsComponent,
    UserActionPermissionsComponent,
    UserPersonalInfoComponent,
    UserChannelPermissionsComponent,
    UserActionPermissionsComponent,
    FuturePreviewComponent,
    MediaTranscoderComponent,
    CalendarExpandableComponent,
    CalendarExpandableEditableTimeComponent,
    CalendarExpandableProgressBarComponent,
    CalendarExpandableAutopilotEventComponent,
    CalendarExpandableGraphicsEventComponent,
    CalendarExpandableSignalEventComponent,
    CalendarExpandableFloatingMediaEventComponent,
    CalendarExpandablePickerComponent,
    CalendarExpandableInOutPickerComponent,
    CalendarExpandableRedLineIndicatorComponent,
    CalendarFilterSecEventsComponent,
    CalendarExpandableNewSecEventComponent,
    CalendarGridColumnsCustomizationComponent,
    MarkerLibraryItemComponent,
    CalendarGridSecEventsPopupComponent,
    DtmfPopoverComponent,
    MarkerPopoverComponent,
    ImportSegmentsCsvComponent,
    LoopFillShowsPopupComponent,
    ChannelJsonEditorComponent,
    LayoutLibraryItemComponent,
    BlocksCalendarComponent,
    BlockLibraryItemComponent,
    EditBlockHeaderComponent,
    BroadcastLibraryItemComponent,
    TenantSettingsSelectAiModelComponent,
    LiveOtherUserEnteredComponent,
    ChooseDayAndTimeComponent,
  ],
  providers: [
    Socket,
    UI,
    ArraysService,
    Config,
    Auth,
    InitService,
    HttpService,
    GraphicsMapper,
    MediaMapper,
    TagMapper,
    AutopilotMapper,
    WindowsNotificationService,
    ReportsService,
    UserService,
    SuperuserService,
    UserMapper,
    ChannelMapper,
    UploadService,
    CountryService,
    ShowRepositoryImpl,
    SearchService,
    CalendarSearchService,
    Logger,
    CalendarService,
    CalendarUIService,
    StorageService,
    SessionStorageService,
    PopoverService,
    SchedulerAsideService,
    RecordingService,
    MediaService,
    TenantService,
    CalendarFilterSecEventsComponent,
    CalendarListComponent,
    CopyShowsViewModel,
    CsvExportService,
    {
      provide: IUserBrandingRepository,
      useClass: UserBrandingRepository,
    },
    {
      provide: IMediaTranscoderRepository,
      useClass: MediaTranscoderRepository,
    },

    UserBrandingService,
    {
      provide: ICloudStorageProviderFactory,
      useClass: CloudStorageProviderFactory,
      multi: false,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: appInitFactory,
      multi: true,
      deps: [InitService],
    },
    {
      provide: GraphicsRepository,
      useClass: GraphicsRepositoryImpl,
    },
    {
      provide: MediaRepository,
      useClass: MediaRepositoryImpl,
    },
    {
      provide: SubtitleRepository,
      useClass: SubtitleRepositoryImpl,
    },
    {
      provide: AudioRepository,
      useClass: AudioRepositoryIml,
    },
    {
      provide: TagRepository,
      useClass: CachedTagRepositoryImpl,
    },
    {
      provide: AutopilotRepository,
      useClass: AutopilotRepositoryImpl,
    },
    {
      provide: UserRepository,
      useClass: UsersRepositoryImpl,
    },
    {
      provide: ChannelRepository,
      useClass: ChannelRepositoryImpl,
    },
    {
      provide: UploadMediaReportRepository,
      useClass: UploadMediaReportRepositoryImpl,
    },
    {
      provide: BatchRulesRepository,
      useClass: BatchRulesRepositoryImpl,
    },
    {
      provide: ShowRepository,
      useClass: ShowRepositoryImpl,
    },
    {
      provide: LiveFeedRepository,
      useClass: LiveFeedRepositoryImpl,
    },
    {
      provide: DynamicPromoRepository,
      useClass: DynamicPromoRepositoryImpl,
    },
    {
      provide: TenantSettingsRepository,
      useClass: CachedTenantSettingsRepositoryImpl,
    },
    {
      provide: ChannelTemplateRepository,
      useClass: ChannelTemplateRepositoryCached,
    },
    {
      provide: TenantRepository,
      useClass: TenantRepositoryImpl,
    },
    {
      provide: CategoryRepository,
      useClass: CategoryRepositoryImpl,
    },
    {
      provide: ITenantStorageOptionRepository,
      useClass: TenantStorageOptionRepository,
    },
    {
      provide: OutpostRepository,
      useClass: OutpostRepositoryImpl,
    },
  ],
  exports: [TopHeaderComponent],
  bootstrap: [AppComponent],
})
export class AppModule {}
